/**
 * Stripe Provider
 *
 * Wraps children in Stripe Elements context with lazy-loaded Stripe.js.
 * Only loads Stripe.js when a payment page is reached (not on every page).
 *
 * Story: SCRUM-567 - Stripe Payment Flow
 */

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

let stripePromise = null;

function getStripePromise(publishableKey) {
  if (!stripePromise) {
    stripePromise = loadStripe(publishableKey);
  }
  return stripePromise;
}

export default function StripeProvider({ publishableKey, clientSecret, children }) {
  const options = {
    clientSecret,
    appearance: {
      theme: 'stripe',
      variables: {
        colorPrimary: '#2D5016',
        borderRadius: '8px',
      },
    },
  };

  return (
    <Elements stripe={getStripePromise(publishableKey)} options={options}>
      {children}
    </Elements>
  );
}
